import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { createUseStyles } from "react-jss";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { useQuery } from "@apollo/client";
import { MOBILE_OFFERED_TARIFFS } from "Services/queries";
import { DECLINATION_QUERY } from "Configs/queries";
import withDefaultParams from "Services/withDefaultParams";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import TagButtonComponent from "Containers/TagButtonComponent";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";
import MobileTariffList from "ComponentsUI/MobileTariffList";
import { CommonNoTariffsInfo, NoTariffsInfo } from "ComponentsUI/InfoBlocks";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import { StubOperatorTariffs } from "ComponentsUI/Stub";

const useStyles = createUseStyles({
	noFindTariffsContainer: {
		margin: "0 0 50px 0",
	},
});

const OfferedTariffsMobileContainer = (props) => {
	let {
		ApplicationModel: { text },
		match: { params },
		mobileTags,
		operatorRatesMobile,
		ratesMobile,
	} = props;
	const match = useWithDefaultParams();
	let regionUrl = match?.params?.regionUrl;

	const classes = useStyles();

	// Запрос в БД на предложенные тарифы
	let offeredTariffs = useQuery(MOBILE_OFFERED_TARIFFS, {
		variables: {
			region_url: regionUrl,
			limitProvider: 1,
			providerJoin: true,
		},
	});

	// Запрос на склонение регионов
	const regionDeclination = useQuery(DECLINATION_QUERY, {
		variables: {
			filter: `url=${regionUrl}`,
		},
	});

	// Срохранение в переменную один из доступных тарифов
	let selectedTariff = offeredTariffs?.data?.tariffsOffered?.data;

	useEffect(() => {
		if (selectedTariff?.length) {
			sendMetriks("OPEN_RECENTLY_CONNECTED_OPERATORY");
		}
	}, [offeredTariffs.loading]);

	// Условия показать экран загрузки
	if (offeredTariffs.loading || regionDeclination.loading) {
		return <StubOperatorTariffs />;
	}

	return (
		<PaddingTop>
			<PaddingBottom>
				<Container>
					<Row>
						<div className={classes.noFindTariffsContainer}>
							<CommonNoTariffsInfo text={text.NO_FIND_OPERATOR_TARIFFS} />
						</div>
					</Row>

					<TagButtonComponent
						mobileTags={mobileTags}
						text={text}
						tagCode={params.tagCode}
						operatorRates={operatorRatesMobile}
						ratesMobile={ratesMobile}
						operatorStyle={true}
					/>
					{selectedTariff && !!selectedTariff.length && (
						<Row>
							<MobileTariffList
								tariffs={selectedTariff}
								thisOfferedTariff={true}
								declinationsName={regionDeclination.data?.region.declinations.prepositional}
								text={text}
							/>
						</Row>
					)}
					{(!selectedTariff || !selectedTariff.length) && (
						<EmptyStubWrapper
							headerText={text.NO_TARIFFS_HEADER}
							displayText={<NoTariffsInfo text={text} ratesMobile={true} />}
							buttonText={text.TO_MAIN_PAGE}
							iconHeader={"icon-balance"}
							iconButton={"icon-playlist-add"}
						/>
					)}
				</Container>
			</PaddingBottom>
		</PaddingTop>
	);
};

export default withRouter(
	withDefaultParams(inject("ApplicationModel")(OfferedTariffsMobileContainer))
);
